import { Button } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { Form, Formik } from 'formik'
import React, { useMemo } from 'react'
import * as yup from 'yup'
import FormikTextField from '../../Formik/FormikTextField'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles(theme => ({
  placeholder: {
    '& input::placeholder': {
      color: '#666',
      fontWeight: 400,
      fontSize: 'inherit',
      letterSpacing: '0.3px',
      opacity: 1,
    },
  },
}))

export interface SubscribeFormData {
  email: string
}

interface FooterSubscribeFormProps {
  onSubmit(values: SubscribeFormData): void
}

const FooterSubscribeForm: React.FC<FooterSubscribeFormProps> = ({ onSubmit }) => {
  const { t, i18n } = useTranslation()
  const classes = useStyles()

  const schema = useMemo(
    () =>
      yup.object().shape<SubscribeFormData>({
        email: yup
          .string()
          .email(t('formErrors.invalidEmail', 'Invalid email'))
          .required(t('formErrors.valueIsRequired', 'This value is required')),
      }),
    [t, i18n.language]
  )
  return (
    <Formik<SubscribeFormData>
      initialValues={{ email: '' }}
      validationSchema={schema}
      onSubmit={(values, formikHelpers) => {
        onSubmit(values)
        formikHelpers.resetForm()
      }}
    >
      <Form className='bg-white'>
        <div className='mt-10 grid' style={{ gridTemplateColumns: '1fr auto' }}>
          <div>
            <FormikTextField
              name='email'
              placeholder={t('placeholder.enterYourEmail', 'Enter your email.')}
              className={classes.placeholder}
              inputProps={{ style: { padding: '11px 14px' } }}
              hideError
            />
          </div>
          <div>
            <Button className='h-full' variant='contained' color='primary' type='submit' disableElevation fullWidth>
              <span className='tracking-1 font-bold whitespace-nowrap'>{t('button.signUp', 'Sign Up')}</span>
            </Button>
          </div>
        </div>
      </Form>
    </Formik>
  )
}

export default FooterSubscribeForm
